import { getJson, postJson, postForm } from "./http";

export const getDailyByEmployeeMonth = ({ empleado, fecha }) =>
  getJson("get.php", { Empleado: empleado, Fecha: fecha });

export const getDailyByEmployee = ({ empleado }) =>
  getJson("get.php", { Empleado: empleado });

export const getDailyByDate = ({ fecha }) =>
  getJson("get.php", { Fecha: fecha });

export const getUsers = ({ fecha } = {}) =>
  getJson("getUsers.php", fecha ? { Fecha: fecha } : {});

export const getHours = ({ empleado, fecha }) =>
  getJson("getHoras.php", { Empleado: empleado, Fecha: fecha });

export const getAfternoon = () => getJson("getTardes.php");

export const setAfternoonType = ({ empleado, fecha, tipoTarde }) =>
  getJson("setHoras.php", {
    Empleado: empleado,
    Fecha: fecha,
    Tipo_Tarde: tipoTarde,
  });

export const setHours = ({ empleado, fecha, turno }) =>
  getJson("setHoras.php", { Empleado: empleado, Fecha: fecha, Turno: turno });

export const updateHours = ({ empleado, fecha, turno, ...fields }) =>
  getJson("setHoras.php", {
    Empleado: empleado,
    Fecha: fecha,
    Turno: turno,
    ...fields,
  });


export const saveTask = (payload) => postJson("saveTask.php", payload);

export const getExits = () => getJson("getSalidas.php");

export const changeTaskDone = ({ id, hecho, task_date }) =>
  postJson("change.php", { id, Hecho: hecho, task_date });

export const removeTask = (payload) =>
  postJson("remTask.php", payload);

export const reassignTask = (payload) =>
  postJson("reasignTask.php", payload);

export const saveNotes = ({ userId, notas }) => {
  const form = new FormData();
  form.append("userId", userId);
  form.append("Notas", notas);
  return postForm("saveNotas.php", form);
}
